import MenuBar from "./Component/MenuBar";
import PageBanner from './Component/PageBanner';
import Sidebar from './Component/Sidebar';
import { Link } from 'react-router-dom'
import BlogsCard from './Component/BlogsCard'
import BlogsData from './Component/BlogsData'
import Footer from './Component/Footer';
const Blogs = (props) => {
    return (
        <>
            <MenuBar />
            <Sidebar />



            <PageBanner title="Blogs" current="BLOGS" />




            <section className="causes-section causes-page load-more-section" >
                <div className="auto-container">

                    <div className="row clearfix">

                        {/* <!--Cause Block--> */}

                        {
                            BlogsData.map((val, index) => {
                                return (

                                    <BlogsCard
                                        key={val.id}
                                        imgsrc={val.imgsrc}
                                        Linkink={val.Link}
                                        title={val.title}
                                        EventDate={val.EventDate}


                                        Desc={val.Desc}

                                       



                                    />
                                )


                            })

                        }




                    </div>

                    {/* <div className="load-more"><a href="#" className="theme-btn load-more-btn">load more</a></div> */}

                </div>
            </section>

            <Footer />

        </>


    )

}


export default Blogs;
